import React, { Component } from 'react';
import { translate } from 'react-i18next';

class Disclaimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDisclaimer: props.showFull || false,
    };
    this.fullDisclaimer = React.createRef();
  }

  componentDidUpdate() {
    if (this.state.showDisclaimer) {
      this.fullDisclaimer.scrollIntoView({ behavior: 'smooth' });
    }
  }

  render() {
    const { t, showFull } = this.props;
    const { showDisclaimer } = this.state;
    return (
      <div className="disclaimer">
        <div className="disclaimer__intro">
          <p dangerouslySetInnerHTML={{ __html: t('disclaimer.copy') }} />
          {!showFull && (
            <p>
              {showDisclaimer ? (
                <a onClick={() => this.setState({ showDisclaimer: false })}>
                  {t('disclaimer.hide_link')}
                </a>
              ) : (
                <a onClick={() => this.setState({ showDisclaimer: true })}>
                  {t('disclaimer.show_link')}
                </a>
              )}
            </p>
          )}
        </div>
        {showDisclaimer && (
          <div className="disclaimer__full" ref={(node) => (this.fullDisclaimer = node)}>
            <p dangerouslySetInnerHTML={{ __html: t('disclaimer.full_copy') }} />
          </div>
        )}
      </div>
    );
  }
}

export default translate('translations')(Disclaimer);



// WEBPACK FOOTER //
// ./src/components/disclaimer.js